import schema from './schemaVersions/v12.js';
	const finalSchema = { wip: false, ...schema };
	export default finalSchema;